import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { run, RuleRunner } from 'Pods/Shared/RuleRunner'
import { required, isEmail, isLimitedLength } from 'Pods/Shared/Rules/Rules'
import InputField from 'Pods/Shared/InputField'

const fieldValidations = [
  RuleRunner('email', 'Email', required, isEmail, isLimitedLength),
]

class AccountConfirmation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: this.props.email,
      showError: false,
      successMessage: false,
      validationErrors: {},
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.errorFor = this.errorFor.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitError = this.onSubmitError.bind(this)
  }

  handleInputChange(e) {
    const newState = this.state

    newState[e.target.name] = e.target.value
    newState.validationErrors = run(newState, fieldValidations)

    this.setState(newState)
  }

  onSubmit(e) {
    e.preventDefault()

    this.setState({ showErrors: true })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
      axios.post('/verify-email', {
        user: {
          email: this.state.email,
          reset_confirmation: this.props.resetConfirmation,
        },
      }).then(response => this.onSubmitSuccess(response, e)).catch(error => this.onSubmitError(error))
    }
  }

  onSubmitSuccess(response, e) {
    this.setState({ successMessage: response.data.successMessage })
  }

  onSubmitError(error) {
    this.setState({ validationErrors: { email: error.response.data.errors.join(', ') } })
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  render() {
    return (
      <Fragment>
        <header className="verify-email-header">
          <div className="container-fixed">
            <div className="row">
              <div className="col-12 header-text">
                <h1 className="heading-64 heading-white text-light">Thanks for registering</h1>
                <p>Please check your inbox and confirm your email address to continue.</p>
              </div>
            </div>
          </div>
          <div className="user-credits u-text-left">
            <div className="container-fixed">
              <div className="row">
                <div className="col-12">
                  Featured artwork by:
                  <a className="link--darker" href="https://www.cgtrader.com/damscool" target="_blank">Damien Peinoit</a>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="content-section">
          <div className="container-fixed">
            <div className="heading-32 u-text-center">Didn't receive an email?</div>
            <div className="heading-24 u-text-center">Resend confirmation instructions</div>
            <div className="verify-email__resend-confirmation">
              <div className="card">
                <div className="l-inner">
                  <div className="user-auth-container u-text-left">
                    <form onSubmit={this.onSubmit}>
                      <InputField
                        label="Email"
                        placeholder="e.g. example@email.com"
                        id="email"
                        name="email"
                        required
                        value={this.state.email}
                        formClassName="form-group-grey"
                        inputClassName="form-control-grey form-control--with-placeholder"
                        errorText={this.errorFor('email')}
                        showError={this.state.showErrors}
                        onChange={this.handleInputChange}
                        disabled={this.state.successMessage !== false}
                      />
                      <div className="session-actions u-text-center">
                        <button className="btn btn-primary btn-lg" type="submit" disabled={this.state.successMessage !== false}>Resend confirmation instructions</button>
                      </div>
                      { this.state.successMessage && <div className="text-green">{this.state.successMessage}</div> }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

AccountConfirmation.propTypes = {
  resetConfirmation: PropTypes.bool.isRequired,
  email: PropTypes.string,
}

AccountConfirmation.defaultProps = {
  email: '',
}

export default AccountConfirmation
